import React, { Component } from "react"
import { Link, graphql } from "gatsby"
import PropTypes from "prop-types"
import Layout from "../layouts/index"
import config from "../config/site"
import SEO from "../components/seo"
import * as stringUtils from "../utils/string"

class CategoryTemplate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: props.data,
      postsPerPage: config.postsPerPage,
      postsIncrementBy: config.postsIncrementBy,
      counter: 0,
      category: props.pageContext.category,
    }
  }

  componentDidMount() {
    const { data, postsPerPage, postsIncrementBy } = this.state
    const posts = data.allWordpressPost.edges
    this.setState({ counter: posts.slice(0, postsPerPage).length })
  }

  loadMore = () => {
    const { postsPerPage, counter } = this.state
    this.setState({
      postsPerPage: postsPerPage + 5,
      counter: counter + 1,
    })
  }

  render() {
    const { data, postsPerPage, category, counter } = this.state
    const posts = data.allWordpressPost.edges

    return (
      <Layout cssClass="posts categories blog-style">
        <SEO title={stringUtils.sanitize(category.name)} />
        <div className="main-content">
          <h1 className="heading-title">
            Blog
            <p className="heading-category-title">
              Articles avec la catégorie <span style={{ textTransform: `lowercase` }}>{`${category.name}`}</span>
            </p>
          </h1>

          <div className="posts-wrapper">
            {posts.slice(0, postsPerPage).map(({ node }) => (
              <div className="post" key={node.slug}>
                <div className="post-content">
                  <ul className="post-categories">
                    {node.post_categories.map(c => (
                      <li
                        className="post-category"
                        key={c.color}
                        style={{
                          color: `${c.text_color}`,
                          backgroundColor: `${c.color}`,
                          borderColor: `${c.color}`,
                        }}
                      >
                        <Link
                          className="post-category-link"
                          to={`/blog/categories/${c.slug}`}
                          style={{ textDecoration: `none` }}
                        >
                          {c.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                  <Link className="post-link" to={`/blog/${node.slug}`} style={{ textDecoration: `none` }}>
                    <h3 className="post-title" dangerouslySetInnerHTML={{ __html: node.title }} />
                    <div
                      className="post-excerpt"
                      dangerouslySetInnerHTML={{ __html: `${node.excerpt.substring(0, 250)}` }}
                    />
                  </Link>
                  <span className="post-author">
                    <div className="post-author-link">
                      <div className="author-thumb">
                        <img src={node.author_meta.avatar_url} alt="" />
                      </div>
                      <div>
                        <span className="author-name">{node.author_meta.display_name}</span>
                        <span className="post-date">
                          {new Date(node.date).toLocaleDateString("fr-FR", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          })}
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            ))}
          </div>
          {counter < posts.length && (
            <div className="load-more-wrapper">
              <a role="button" tabIndex={0} onClick={this.loadMore} onKeyUp={() => false} className="load-more">
                Voir plus
              </a>
            </div>
          )}
        </div>
      </Layout>
    )
  }
}

export default CategoryTemplate
export const pageQuery = graphql`
  query currentPostsQuery($id: String!) {
    allWordpressPost(
      sort: { fields: [date], order: DESC }
      filter: { categories: { elemMatch: { id: { eq: $id } } } }
    ) {
      edges {
        node {
          title
          excerpt
          slug
          date(formatString: "MMMM DD, YYYY")
          author_meta {
            display_name
            avatar_url
            twitter_url
            linkedin_url
          }
          post_categories {
            text_color
            color
            title
            slug
          }
        }
      }
    }
  }
`

CategoryTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
}
